import { webviewInterface } from './webview';

(function initWebviewBridge() {
  if (!window.webkit?.messageHandlers && !window.Android) return;
  if (window.NativeBridge) return;

  const pending = new Map();

  function call(name: string, data?: object) {
    const id = `${name}-${new Date().getTime()}`;
    const payload = { id, ...data };
    webviewInterface(name, payload);

    return new Promise((resolve, reject) => {
      const t = setTimeout(() => {
        pending.delete(id);
      }, 3000);

      pending.set(id, {
        resolve: (payload: object) => {
          if (t) clearTimeout(t);
          resolve(payload);
        },
        reject: (error: object) => {
          if (t) clearTimeout(t);
          reject(error);
        },
      });
    });
  }

  window.__nativeBridge = {
    resolve: (data: object) => {
      const { id } = data as unknown as { id: string };
      if (!id) return;
      const { resolve } = pending.get(id);

      resolve(data);
      pending.delete(id);
    },
    reject: (error: object) => {
      const { id } = error as unknown as { id: string };
      if (!id) return;

      const { reject } = pending.get(id);

      reject(error);
      pending.delete(id);
    },
  };

  window.NativeBridge = {
    call,
  };
})();
